import { Component, Injector, Input, OnInit, ViewChild, ViewEncapsulation, Renderer2, EventEmitter, Output } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { MaterialService } from 'src/app/material/material.service';
import { ToastrService } from 'ngx-toastr';
import { CommonDataModel } from '../common-data-model';
import { CommonService } from 'src/app-core/services/common.service';
import { NgForm } from '@angular/forms';
import * as _ from 'lodash';

const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
    while (el && el.parentElement) {
        if (hasClass(el.parentElement, className)) {
            return true;
        }
        el = el.parentElement;
    }
    return false;
};

@Component({
    selector: 'app-container-noncushioning-list',
    templateUrl: './container-noncushioning-list.component.html',
    styleUrls: ['./container-noncushioning-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ContainerNoncushioningListComponent extends AppComponentBase implements OnInit {
    @Input() set containerIdParam(containerId: number) {
        if (containerId) {
            this.containerId = containerId;
        }
    }

    constructor(
        injector: Injector,
        private materialService: MaterialService,
        private toastr: ToastrService,
        private commonService: CommonService,
        private renderer: Renderer2
    ) {
        super(injector);
        this.renderer.listen(
            'document',
            'click',
            ({ target }) => {
                if (!isChildOf(target, 'nonCushioningGrid')) {
                    if (this.nonCushioningMaterialForm.valid) {
                        this.grid.closeRow(this.editedRowIndex);
                        this.emitEnableSaveButton.emit();
                        this.editedRowIndex = null;
                    }
                }
            });
    }
    @ViewChild('grid', { static: true }) public grid: GridComponent;
    @ViewChild('nonCushioningMaterialForm', { static: false }) nonCushioningMaterialForm: NgForm;
    @Output() emitEnableSaveButton: EventEmitter<any> = new EventEmitter();
    @Output() collapseEmit: EventEmitter<any> = new EventEmitter();
    @Output() emitReCalculatePackagingQuantity: EventEmitter<any> = new EventEmitter();

    @Input() isExpanded: any;
    @Input() corporatePackgingAndId: any;
    @Input() readOnly: boolean;

    commonDataModal = new CommonDataModel();
    categories: Array<any>;
    defaultMaterialsList: Array<any>;
    units: Array<any>;
    gridItems: any = {
        data: [],
        total: 0
    };
    editedRowIndex: number;
    containerId: number;
    containerQuantity: any;
    containerDimention = _.cloneDeep(this.commonDataModal.containerDimention);
    isDisabledForm = false;

    ngOnInit() {
        this.getCategories();
        this.getUnits();
        this.getDefaultMaterials();
    }

    openAccordian(open: string, state: boolean) {
        if (open) {
            this.isExpanded = state;
            this.collapseEmit.emit();
        }
    }

    closeAccordian(open: string, state: boolean) {
        if (close) {
            this.isExpanded = state;
            this.collapseEmit.emit();
        }
    }


    getCategories(): void {
        this.materialService.getCategories().subscribe(response => {
            if (response.isSuccess) {
                this.categories = response.data.filter(item => [3, 4, 7].includes(item.id));
            }
        });
    }

    getDefaultMaterials(dataItem?: any, material?: any) {
        let queryParam = '';
        if (this.corporatePackgingAndId && this.corporatePackgingAndId.isCorporate) {
            queryParam += '&CallFrom=999'
        } else if (this.corporatePackgingAndId && this.corporatePackgingAndId.id && this.corporatePackgingAndId.id > 0) {
            queryParam += '&id=' + this.corporatePackgingAndId.id;
        }

        this.commonService.getCleatsList(queryParam).subscribe(response => {
            if (response.isSuccess) {
                const materialCategoryList = response.data.find(x => dataItem ? x.materialCategoryId == material.id : true);
                this.defaultMaterialsList = response.data;
                if (dataItem) {
                    dataItem.materialCategoryId = material.id;
                    if (materialCategoryList) {
                        dataItem.materialId = materialCategoryList.id;
                        this.onMaterialChange(dataItem.materialId, dataItem, false);
                    } else {
                        this.toastr.warning('No Materials Found for the Material Category');
                        dataItem.materialId = null;
                    }
                }
            }
        });
    }

    onCategoryChange(material: any, dataItem: any) {
        dataItem.defaultMaterialList = this.defaultMaterialsList.filter(item => item.materialCategoryId == material.id);
        dataItem.isChanged = true;
        this.getDefaultMaterials(dataItem, material);
    }


    defaultMaterials(data: any) {
        if (this.defaultMaterialsList) {
            return this.defaultMaterialsList.filter(item => item.materialCategoryId == data.categoryId);
        }
    }

    getUnits(): void {
        this.materialService.getUnits().subscribe(response => {
            if (response.isSuccess) {
                this.units = response.data;
            }
        });
    }

    onAddPrepMaterial() {
        if (this.nonCushioningMaterialForm.valid) {
            this.gridItems.data.splice(0, 0, this.getNewMaterial(3));
            this.nonCushioningMaterialForm.form.markAsDirty();
            this.emitEnableSaveButton.emit();
        }
    }

    onCategoryOpen(index: number) {
        if (index !== this.editedRowIndex) {
            if (this.nonCushioningMaterialForm.valid) {
                this.grid.closeRow(this.editedRowIndex);
                this.editedRowIndex = index;
                this.grid.editRow(index);
            }
        }
    }

    getNewMaterial(categoryId: number): any {
        const itemModel = Object.assign({}, this.commonDataModal.containerMaterialModel);
        itemModel.categoryId = categoryId;
        const defaultMaterial = this.defaultMaterialsList.find(item => item.materialCategoryId == itemModel.categoryId);
        if (defaultMaterial) {
            itemModel.materialId = defaultMaterial.id;
        } else {
            itemModel.materialId = null;
        }
        itemModel.defaultMaterialList = this.defaultMaterialsList.filter(item => item.materialCategoryId == itemModel.categoryId);
        itemModel.unit = 'Inches';
        itemModel.unitId = 1;
        itemModel.isChanged = true;
        this.onMaterialChange(itemModel.materialId, itemModel, false);
        this.emitEnableSaveButton.emit();
        itemModel.layerOrder = this.gridItems.data.length + 1;
        return itemModel;
    }

    onMaterialChange(material: any, dataItem: any, isFromEvent: boolean) {
        this.materialService.getMaterialDimension(isFromEvent ? material.id : material).subscribe(response => {
            if (response.isSuccess) {
                this.commonService.objectMapping(dataItem, response.data);
                dataItem.nonStdLabor = response.data.laborMinutesPer;
                dataItem.unit = this.units.find(item => item.id == dataItem.unitId).abbreviatedValue;
                dataItem.description = null;
                dataItem.addsToContainer = true;
                dataItem.isChanged = true;
                if (dataItem.categoryId == 3) {
                    this.emitReCalculatePackagingQuantity.emit();
                } else {
                    dataItem.weightLBS = response.data.weight;
                    dataItem.cost = response.data.totalCost.toFixed(2);
                }
            }
        });
    }

    onAddFillMaterial() {
        if (this.nonCushioningMaterialForm.valid) {
            this.gridItems.data.splice(0, 0, this.getNewMaterial(7));
            this.nonCushioningMaterialForm.form.markAsDirty();
            this.emitEnableSaveButton.emit();
        }
    }

    onAddHardwareMaterial() {
        if (this.nonCushioningMaterialForm.valid) {
            this.gridItems.data.splice(0, 0, this.getNewMaterial(4));
            this.nonCushioningMaterialForm.form.markAsDirty();
            this.emitEnableSaveButton.emit();
        }
    }

    onRemoveMaterial(index: any) {
        this.gridItems.data.splice(index, 1);
        this.nonCushioningMaterialForm.form.markAsDirty();
        this.emitReCalculatePackagingQuantity.emit();
        this.gridItems.data.map((item, index) => {
            item.layerOrder = index + 1;
        });
    }

    onCellClickHandler({ sender, rowIndex }, grid: any) {
        if (!this.isDisabledForm) {
            grid.closeRow(this.editedRowIndex);
            this.editedRowIndex = rowIndex;
            sender.editRow(rowIndex);
        }
    }

    onQuantityChange(dataItem: any) {
        dataItem.isChanged = true;
        this.emitEnableSaveButton.emit();
        this.emitReCalculatePackagingQuantity.emit();
    }

    onUnitQuantityChange(dataItem: any) {
        dataItem.isChanged = true;
        this.emitEnableSaveButton.emit();
    }

    onDescChange(dataItem: any) {
        dataItem.isChanged = true;
        this.emitEnableSaveButton.emit();
    }

    handleFilter(value: any, dataItem: any) {
        dataItem.defaultMaterialList = this.defaultMaterialsList.filter((s) => s.materialCategoryId == dataItem.categoryId && s.materialName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }
}
